export default {
  title: 'Réservations CSV',
  buttons: {
    generate: 'Générer & télécharger',
  },
  fields: {
    date_range: 'Plage de dates (facultatif)',
  },
  errors: {
    invalid_date_range: 'Veuillez sélectionner une plage de dates valide',
  },
};
